import React from "react"
import { Grid } from "@material-ui/core"
import { useParams } from "react-router-dom"

import { lovableAppUrl } from "@/config/url"
import useStyles from "@/pages/Admin/Widgets/WidgetEditor/styles"

const WidgetEditor: React.FC = () => {
	const classes = useStyles()
	const { widgetId } = useParams<{ widgetId?: string }>()

	const widgetEditorUrl = `${lovableAppUrl.widgetEditorURL}/${widgetId}`

	return (
		<Grid
			container
			className={classes.pageContainer}
		>
			<Grid item xs>
				<iframe
					src={widgetEditorUrl}
					title="Editar Widget"
					className={classes.widgetEditorIframe}
				/>
			</Grid>
		</Grid>
	)
}

export default WidgetEditor
